import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { PropertyCardComponent } from '../property-card/property-card.component';
import { PropertySearchCardVM } from '../../../models/property-search-card.vm';

/**
 * Grid responsivo de resultados. Presentacional: recibe los ViewModels y
 * delega cada item a {@link PropertyCardComponent}. Solo conoce el Router
 * para navegar al detalle (única responsabilidad de navegación del grid).
 */
@Component({
    selector: 'app-custom-card',
    standalone: true,
    imports: [CommonModule, PropertyCardComponent],
    templateUrl: './custom-card.component.html',
    styleUrls: ['./custom-card.component.scss'],
})
export class CustomCardComponent {
    @Input() properties: PropertySearchCardVM[] = [];

    constructor(private router: Router) {}

    open(propertyId: number): void {
        this.router.navigate(['/property', propertyId]);
    }

    trackById(_: number, item: PropertySearchCardVM): number {
        return item.propertyId;
    }
}
